/**
 * UMED SUBMITTED TO DCF, from the status menu (PA Sale to Approval - IF THIS THEN THAT, SUB 06: "Add this status option").
 *
 * The status word follows an act and the menu never writes a word without its act, so picking the word records nothing.
 * It opens this chooser in the case panel with the real ways to send, each of which goes to the act that already exists:
 *   Fax to DCF from eMerge               the packet panel's Fax to DCF (SUB 05), when the fax service is on and the packet is ready;
 *   I faxed it outside eMerge            the packet panel's Record fax sending;
 *   I uploaded it in the DCF account     the packet panel's Confirm DCF upload.
 * The word is written by whichever of those is completed, and never by this chooser.
 */
import React, { useEffect, useState } from 'react';
import { umedApi } from './umedApi';
import type { PacketPreparationStatus } from './umedApi';

export type SendingChoice = 'fax-dcf' | 'record-fax' | 'confirm-upload';

export default function SendingChooser({ caseId, canSubmit, onChoose }: { caseId: string; canSubmit: boolean; onChoose: (kind: SendingChoice) => void }) {
  const [s, setS] = useState<PacketPreparationStatus | null>(null);
  const first = React.useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    let live = true;
    setS(null);
    umedApi.packetPreparation(caseId).then((r) => { if (live && r.success && r.data) setS(r.data); }).catch(() => undefined);
    return () => { live = false; };
  }, [caseId]);
  useEffect(() => { if (first.current) first.current.focus({ preventScroll: true }); }, [s]);
  if (!canSubmit) return null;
  const faxFromEmerge = Boolean(s && s.fax_service?.enabled && s.fax_service.can_send);
  return (
    <div className="um-form" role="group" aria-label="UMED submitted to DCF: how was it sent?" data-testid="sending-chooser">
      <p><strong>UMED SUBMITTED TO DCF</strong>: how is it being sent? Nothing is recorded until you finish the one you pick.</p>
      <div className="btns">
        {faxFromEmerge && <button type="button" className="um-open um-primary" ref={first} onClick={() => onChoose('fax-dcf')}>Fax to DCF from eMerge</button>}
        <button type="button" className="um-open" ref={faxFromEmerge ? undefined : first} onClick={() => onChoose('record-fax')}>I faxed it outside eMerge (record fax sending)</button>
        <button type="button" className="um-open" onClick={() => onChoose('confirm-upload')}>I uploaded it in the DCF account (confirm DCF upload)</button>
      </div>
    </div>
  );
}
